import kafein_logo from "../../assets/img/kafein-logo-white.png";
import logo from "../../assets/img/logo192.png";
import {Alert, Button, Col, Form} from "react-bootstrap";
import React, {useRef, useState} from "react";
import {useFormik} from "formik";
import * as yup from "yup";
import Utils from "../../libraries/utils";
import micro_reporter_api from "../../apis/micro-reporter-api";
import {Toast} from "primereact/toast";
import {useHistory} from "react-router-dom";

const ForgetPasswordRouter = () => {

    const toast = useRef(null);
    const history = useHistory();
    const [success, setSuccess] = useState(false);
    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: yup.object({
            email: yup.string().required('Email can not be blank.').email('Invalid Email')


        }),
        onSubmit: values => {
            forgotPasswordLink(values);
        },
    });


    const forgotPasswordLink = (values) => {

        (async () => {
            let response;
            try {
                Utils.loadingScreen("show");
                // let headers = {"email": values.email, "relatedName": encodeURIComponent(values.email)};
                const config = {};
                response = await micro_reporter_api.post('/micro-reporter/authentication/forgot/password', values, config);
                response.data["lld"] = Date.now();
                localStorage.setItem('user', JSON.stringify(response.data));

                Utils.loadingScreen("hide");
            } catch (err) {
                Utils.loadingScreen("hide");

            }

            if (response !== undefined && response?.status === 200) {
                toast?.current?.show({
                    severity: 'success',
                    detail: 'Email sending is Successfully.'
                });
                setSuccess(true)
                setTimeout(() => {
                    history.push("")
                }, 1500);
            }else{toast?.current?.show({
                severity: 'error',
                detail: 'Email not found.'
            });}
        })();
    };


    return (
        <>
            <Toast ref={toast}/>
            <div className="container">
                <div id="login-form-panel">
                    <div style={{
                        backgroundColor: "#33344a",
                        height: "60px",
                        width: "100%",
                        marginBottom: "20px",
                        padding: "10px 20px"
                    }}>
                        <img
                            src={kafein_logo}
                            width="120"
                            height="35"
                            alt="Kafein"
                            style={{display: "block", marginLeft: "auto", marginRight: "auto", float: "left"}}
                        />
                        <div style={{
                            marginTop: "5px",
                            display: "block",
                            marginLeft: "auto",
                            marginRight: "auto",
                            width: "max-content"
                        }}>
                            <img
                                src={logo}
                                width="30"
                                height="30"
                                className="d-inline-block align-top"
                                alt="Micro Reporter"
                                style={{marginRight: "7px", marginTop: "-2px"}}
                            />
                            <span style={{fontFamily: "Lexend Deca", color: "#ffffff"}}>Micro Reporter</span>
                        </div>
                    </div>
                    <div id="login-center-div">


                        <Form noValidate onSubmit={formik.handleSubmit} id="login-form">
                            <Form.Row>
                                <Form.Group as={Col} md="12" controlId="validationFormik01">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="email"
                                        placeholder=""
                                        onChange={formik.handleChange}
                                        value={formik.values.email}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.email && formik.errors.email ? (
                                        <div style={{
                                            fontFamily: "Lexend Deca",
                                            fontSize: "12px",
                                            color: "#ff0000"
                                        }}>{formik.errors.email}</div>
                                    ) : null}
                                </Form.Group>
                            </Form.Row>
                            <Button disabled={success} type="submit" variant="success" block>Send reset password link to mail</Button>


                        </Form>
                    </div>
                </div>
            </div>
        </>
    )

}
export default ForgetPasswordRouter;
